/** True when the title bar is showing editor chrome for an opened project. */
export function isEditorTitleBarContext(pathname: string, projectOpened: boolean): boolean {
  return pathname.startsWith('/editor') && projectOpened;
}

/** True when play-mode title bar controls (Play / Exit) should render. */
export function shouldShowPlayModeControls(
  pathname: string,
  projectOpened: boolean,
  isPlayMode: boolean,
  isPlayModeStarting: boolean,
): boolean {
  return isEditorTitleBarContext(pathname, projectOpened)
    || isPlayMode
    || isPlayModeStarting;
}
